<router-outlet></router-outlet>

<!-- Global Alert Display -->
<div
  *ngIf="isHomePage && (activeAlerts$ | async) as alerts"
  class="global-alerts">
  <div *ngFor="let alert of alerts" class="alert-banner">
    <h4>{{ alert.title }}</h4>
    <div class="alert-message ql-snow">
      <div class="ql-editor" [innerHTML]="alert.message | formatMessage"></div>
    </div>
    <small>ID: {{ alert.id }} | Type: {{ alert.broadcastTypeId }}</small>
  </div>
</div>
